import Reviews from "components/homepage/reviews";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import React from "react";
import LocalizationMidText from "../localizationMidText";
import WhatsAppComp from "../whatsappComp";
import { MedicalData } from "./config";
import HealthCare from "./healthCare";
import MedicalGrid from "./medicalGrid";

function MedicalTranslation() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Medical translation services"
        content="Are you looking for medical translation services? Tomedes, one of the leading medical translation services, can help you with your medical translation and interpretation needs. With over a decade of experience, Tomedes has been serving the medical community with over 120 languages and 950+ language pairs. We also offer a 1-year guarantee, rapid delivery, and 24/7 customer support. What more could you need?"
        formOrangeHead="Get in touch "
        formWhiteHead="with our Medical Translation Agency"
      />
      <HealthCare />
      <LocalizationMidText
        orangeMidText="medical"
        content="translation services help healthcare providers worldwide eliminate language barriers to better serve communities. We provide secure and accurate solutions delivered on-time by our team of experts."
      />
      <TrustedTranslation
        headColor="text-lightBlue"
        ColorHead="HIPAA"
        SecondWhite="compliant medical translations"
        Content="Serving the needs of healthcare professionals and patients alike, Tomedes is compliant to HIPAA, the Health Insurance Portability and Accountability Act of 1996. The Act provides legislation that safeguards data privacy and security provisions. At Tomedes, your medical translations are secured through NDAs and secure technology. We provide peace of mind as a standard for all your medical translation services."
      />
      <SpeceficTranslation
        FirstOrange="Medical"
        SecondWhite="Document Translation Services done
        by Medical Experts"
        headColor="text-orange"
        Content="The medical field is one that's ripe with specialized terminologies, all branching off of the sciences. Such documents as lab reports, patient history, patient records or electronic health records, and clinical findings can all be translated into the languages you need. Your medical documents will be handled by a medical translator, provided by Tomedes, who is an expert in the medical field. There is an added necessity of an accredited medical translator to translate your documents because only this type of expert is fully equipped to handle these translations."
        backgroundCol="bg-midBlue"
      />
      <MedicalGrid
        backgroundCol="bg-darkBlue"
        bottomBorderText
        footerTitle="Medical Interpretation Services"
        footerDetails="Medical interpretation should be done by a hospital interpreter or a medical language interpreter. These professionals are available at Tomedes medical translation company. We offer consecutive and simultaneous interpretation. Our medical interpreters interpret at all times during the patient's journey, both in synchronous and asynchronous communication. They break down healthcare barriers between the patient and the medical provider, in order to improve medical outcomes for the patient."
        languageCount="Our Full Suite of Medical Translation Services"
        details="Medical translations have never been easier, with over 120 languages to choose from and 950+ available pairings."
        bottomHeading="Common Use Cases"
        data={MedicalData}
      />
      <WhatsAppComp
        backgroundCol="bg-midBlue"
        btnCol="bg-orange"
        btnHoverCol="hover:bg-newOrange-100"
        fHeadCol="text-orange"
        fHead="Looking"
        secondHead="for a Medical Translator?"
        content="If you're looking for a medical translator or medical interpreter, it's time to contact Tomedes. Our client satisfaction rate of 97% proves that our client is at the heart of our philosophy. We're available 24/7 to discuss your translation and interpretation needs, and we respond within 30 minutes."
        btn
      />
      <TranslationServices backgroundCol="bg-darkBlue" />
      <SpeceficTranslation
        FirstOrange="Medical"
        getStarted
        linkName=" "
        SecondWhite="Translation Services in over 120 Languages and 950+ Language Pairs"
        headColor="text-lightBlue"
        Content="Medical translations have never been easier. At Tomedes, we have over 120 languages and 950+ language pairs to choose from. Here's the list of the languages we have currently available. Choose one and partner with Tomedes today."
        backgroundCol="bg-midBlue"
      />
      <div className="bg-cover bg-no-repeat bg-center w-full h-full">
        <img
          src="https://tomedes.gumlet.io/frontend/images/services-new/languages_bg_medical.webp"
          alt=""
          className="w-full md:block hidden"
        />
      </div>
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
    </>
  );
}

export default MedicalTranslation;
